import { http } from '../http';

export async function sendSignOtp(documentUlid: string) {
	const sendSignOtpResponse = await http.post<Record<string, unknown>>(
		`documents/${documentUlid}/send-sign-otp`,
		null,
	);
	if (sendSignOtpResponse) {
		return sendSignOtpResponse;
	} else {
		throw TypeError;
	}
}
